import { useParams, Link } from "react-router-dom";
import { blogPosts } from "@/mocks/blog";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/pages/home/components/Footer";
import { useState } from "react";

export default function BlogPost() {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  if (!post) {
    return (
      <main className="min-h-screen bg-white">
        <Navbar />
        <section className="pt-32 pb-20 text-center">
          <div className="w-16 h-16 flex items-center justify-center mx-auto bg-dark-100 rounded-full mb-4">
            <i className="ri-error-warning-line text-dark-400 text-2xl"></i>
          </div>
          <h1 className="text-2xl font-bold text-dark-900 mb-2">Članak nije pronađen</h1>
          <p className="text-dark-400 mb-6">Ovaj članak ne postoji ili je uklonjen.</p>
          <Link to="/blog" className="inline-flex items-center gap-2 text-brand-600 font-semibold hover:text-brand-700 transition-colors">
            <i className="ri-arrow-left-line"></i>
            Nazad na blog
          </Link>
        </section>
        <Footer />
      </main>
    );
  }

  const relatedPosts = blogPosts
    .filter((p) => p.slug !== post.slug && (p.category === post.category || p.categorySlug === post.categorySlug))
    .slice(0, 2);

  return (
    <main className="min-h-screen bg-white">
      <Navbar />

      <article className="pt-24 md:pt-32">
        <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
          <div className="max-w-4xl mx-auto">
            <Link to="/blog" className="inline-flex items-center gap-2 text-dark-400 hover:text-brand-600 text-sm font-medium transition-colors mb-8">
              <i className="ri-arrow-left-line"></i>
              Nazad na blog
            </Link>

            <div className="mb-4">
              <span className="inline-block bg-brand-50 text-brand-700 text-xs font-semibold px-3 py-1.5 rounded-full mb-4">
                {post.category}
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-dark-900 leading-tight mb-6">
              {post.title}
            </h1>

            <div className="flex flex-wrap items-center gap-4 text-sm text-dark-400 mb-8 pb-8 border-b border-dark-100">
              <span className="flex items-center gap-1.5">
                <i className="ri-user-line"></i>
                {post.author}
              </span>
              <span className="text-dark-200">|</span>
              <span className="flex items-center gap-1.5">
                <i className="ri-calendar-line"></i>
                {post.date}
              </span>
              <span className="text-dark-200">|</span>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line"></i>
                {post.readTime} čitanja
              </span>
            </div>

            <div className="mb-10 rounded-2xl overflow-hidden">
              <img
                src={post.image}
                alt={post.title}
                className="w-full aspect-[16/9] object-cover object-center"
              />
            </div>

            <div
              className="prose prose-lg max-w-none mb-16
                prose-headings:text-dark-900 prose-headings:font-bold prose-headings:mt-10 prose-headings:mb-4
                prose-h2:text-2xl prose-h2:mt-12
                prose-p:text-dark-600 prose-p:leading-relaxed prose-p:mb-4
                prose-strong:text-dark-900
                prose-ul:my-4 prose-li:text-dark-600 prose-li:mb-2
                prose-a:text-brand-600"
              dangerouslySetInnerHTML={{ __html: post.content }}
            ></div>

            <div className="bg-dark-50 rounded-2xl p-8 md:p-10 mb-16 text-center">
              <h3 className="text-xl font-bold text-dark-900 mb-2">
                Želite više ovakvih sadržaja?
              </h3>
              <p className="text-dark-500 text-sm mb-6 max-w-md mx-auto">
                Prijavite se na naš newsletter i dobijajte stručne savete o bezbednosnim sistemima direktno na email.
              </p>
              {subscribed ? (
                <div className="flex items-center justify-center gap-2 text-brand-600 font-semibold">
                  <i className="ri-check-line"></i>
                  Uspešno ste se prijavili!
                </div>
              ) : (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    fetch("https://readdy.ai/api/form/d8h9irscl43d0bibeid0", {
                      method: "POST",
                      headers: { "Content-Type": "application/x-www-form-urlencoded" },
                      body: new URLSearchParams({ email }).toString(),
                    }).then(() => {
                      setSubscribed(true);
                      setEmail("");
                    }).catch(() => {
                      setSubscribed(true);
                    });
                  }}
                  className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
                  data-readdy-form=""
                >
                  <input
                    type="email"
                    name="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Vaša email adresa"
                    className="flex-1 px-5 py-3 rounded-xl border border-dark-200 bg-white text-dark-900 text-sm focus:outline-none focus:border-brand-400 transition-all"
                  />
                  <button
                    type="submit"
                    className="bg-brand-500 hover:bg-brand-600 text-white px-6 py-3 rounded-xl text-sm font-semibold transition-all whitespace-nowrap cursor-pointer"
                  >
                    Prijavi se
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </article>

      {relatedPosts.length > 0 && (
        <section className="py-16 md:py-20 bg-dark-50">
          <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center justify-between mb-10">
                <h2 className="text-2xl md:text-3xl font-bold text-dark-900">Povezani članci</h2>
                <Link to="/blog" className="text-brand-600 hover:text-brand-700 text-sm font-semibold flex items-center gap-2">
                  Svi članci
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                {relatedPosts.map((rp) => (
                  <Link key={rp.slug} to={`/blog/${rp.slug}`} className="group bg-white rounded-2xl border border-dark-100 overflow-hidden hover:-translate-y-1 transition-all duration-300">
                    <div className="flex flex-col sm:flex-row">
                      <div className="sm:w-48 h-40 sm:h-auto bg-dark-100 overflow-hidden flex-shrink-0">
                        <img
                          src={rp.image}
                          alt={rp.title}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                          loading="lazy"
                        />
                      </div>
                      <div className="p-5 flex flex-col justify-center">
                        <span className="text-xs text-dark-400 mb-2">{rp.date}</span>
                        <h3 className="text-base font-bold text-dark-900 mb-2 group-hover:text-brand-600 transition-colors line-clamp-2">
                          {rp.title}
                        </h3>
                        <p className="text-sm text-dark-400 line-clamp-1">{rp.excerpt}</p>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      <Footer />
    </main>
  );
}